/* eslint-disable */ 
<!-- QRimage.vue -->
<!-- No se requiere en este proyecto -->
<template>
<div></div>
</template>